import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

export function MarketplaceListingListCardSkeleton({
  className,
  isGrouped = true,
}: {
  className?: string;
  isGrouped?: boolean;
}) {
  return (
    <div
      className={cn(
        "flex w-full flex-row items-center gap-3 bg-white py-3 pl-4 pr-4",
        isGrouped
          ? "border-b border-gray-200 last:border-b"
          : "border-gray-blue-200 border",
        className
      )}>
      <Skeleton className="border-gray-200 h-28 w-[8.5rem] shrink-0 rounded-xl border-r pr-3" />
      <div className="flex min-h-28 min-w-0 flex-1 flex-col justify-between gap-2">
        <div className="space-y-1.5">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-4/5" />
          <Skeleton className="h-4 w-24 rounded-full" />
        </div>
        <div className="flex items-end justify-between gap-3">
          <div className="flex flex-col gap-0.5">
            <Skeleton className="h-3 w-28" />
            <Skeleton className="h-3 w-20" />
          </div>
          <div className="flex shrink-0 flex-col items-end gap-0.5">
            <Skeleton className="h-3.5 w-8" />
            <Skeleton className="h-5 w-16" />
          </div>
        </div>
      </div>
    </div>
  );
}
